import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Printer from "../src/printer";



Vue.config.productionTip = true

Vue.prototype.$printer= new Printer();

new Vue({
  router,
  store,
  vuetify,  
  render: h => h(App)
}).$mount('#app')
